 // QR Discount Handler - Fixed for Free Gifts and Compare Prices
  (function() {
    'use strict';

    // Configuration
    const CONFIG = {
      cookieName: 'qr_discount_code',
      cookieExpireDays: 30,
      discountPrefix: 'QR',
      discountPercentage: 10,
      debugMode: true
    };

    // Cookie helper functions
    const CookieManager = {
      set: function(name, value, days) {
        const expires = new Date();
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/;SameSite=Lax';
      },

      get: function(name) {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i].trim();
          if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
          }
        }
        return null;
      },

      remove: function(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;';
      }
    };



    // Initialize
    document.addEventListener('DOMContentLoaded', initQRDiscount);

    function initQRDiscount() {
      console.log('[QR Discount] Initializing...');

      // Check URL for discount code
      const urlParams = new URLSearchParams(window.location.search);
      const discountCode = urlParams.get('discount');

      // Store discount if found in URL
      if (discountCode) {
        console.log('[QR Discount] Found in URL:', discountCode);
        CookieManager.set(CONFIG.cookieName, discountCode, CONFIG.cookieExpireDays);

        // Clean URL without redirect
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('discount');
        window.history.replaceState({}, document.title, cleanUrl.pathname + cleanUrl.search);

        showDiscountSavedNotification(discountCode);
      }

      // Check for stored discount
      const storedDiscount = CookieManager.get(CONFIG.cookieName);
      if (storedDiscount) {
        console.log('[QR Discount] Stored discount found:', storedDiscount);
        // showActiveDiscountBadge(storedDiscount);

        // ONLY apply discount if on cart page
        if (window.location.pathname === '/cart') {
          console.log('[QR Discount] On cart page');

          // Check if we just came from applying discount
          const justApplied = urlParams.get('discount_applied') === 'true';

          if (justApplied) {
            // Clean URL
            const cleanUrl = new URL(window.location.href);
            cleanUrl.searchParams.delete('discount_applied');
            window.history.replaceState({}, document.title, cleanUrl.pathname + cleanUrl.search);

            // Just update display, don't reapply
            updateCartDisplayWithOriginalPrices(storedDiscount);
            updateTotalAndSubtotal();
          } else {
            // Check if discount needs to be applied
            checkAndApplyDiscount(storedDiscount);
          }
        } else {
          // Not on cart page
          if (!sessionStorage.getItem('discount_notified')) {
            showPendingDiscountNotification(storedDiscount);
            sessionStorage.getItem('discount_notified', 'true');
          }
        }
      }
    }

    // Check and apply discount
    function checkAndApplyDiscount(discountCode) {
      console.log('[QR Discount] Checking if discount needs to be applied...');

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
           const subtotal = cart.items_subtotal_price / 100;
           const total = cart.total_price / 100; 
           const discount = cart.total_discount / 100;
           
          console.log('[QR Discount] Cart data:', cart);

          // Check if discount is already applied
          const isDiscountApplied = cart.total_discount > 0 ||
                                    (cart.discount_codes && cart.discount_codes.length > 0);

          if (!isDiscountApplied) {
            console.log('[QR Discount] Discount not applied yet, applying now...');

            // Store original prices before applying discount
            storeOriginalPrices(cart);

            // Show loading message
            showApplyingMessage();

            // Apply discount without reload
            setTimeout(() => {
              applyDiscountWithoutReload(discountCode);
            }, 2000);
          } else {
            console.log('[QR Discount] Discount already applied');
             updateCartDisplayWithOriginalPrices(discountCode);
          }
        });
    }

    // Store original prices before discount
    function storeOriginalPrices(cart) {
      const originalPrices = {};
      cart.items.forEach(item => {
        originalPrices[item.key] = {
          price: item.price,
          line_price: item.line_price,
          original_price: item.original_price || item.price,
          original_line_price: item.original_line_price || item.line_price,
          compare_at_price: item.compare_at_price,
          product_title: item.product_title,
          variant_title: item.variant_title,
          properties: item.properties
        };
      });
      sessionStorage.setItem('original_prices', JSON.stringify(originalPrices));
      sessionStorage.setItem('original_total', cart.total_price);
    }

    // Apply discount without page reload
    function applyDiscountWithoutReload(discountCode) {
      console.log('[QR Discount] Applying discount without reload');

      // Use fetch to apply discount
      fetch(`/discount/${discountCode}?redirect=/cart`, {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'manual' // Don't follow redirect
      })
      .then(() => {
        console.log('[QR Discount] Discount applied via fetch');

        // Remove loading message
        const message = document.getElementById('qr-applying-message');
        if (message) message.remove();

        // Update cart display without reload
         setTimeout(() => {
           updateCartDisplayWithOriginalPrices(discountCode);
           updateTotalAndSubtotal();
            removeDuplicatePriceContainers(); 
         }, 1000);
      })
      .catch(() => {
        // Fallback: redirect with flag
        window.location.href = `/discount/${discountCode}?redirect=/cart&discount_applied=true`;
      });
    }

    // Update cart display with original prices
    function updateCartDisplayWithOriginalPrices(discountCode) {
      console.log('[QR Discount] Updating display with original prices');

      // Get stored original prices
      const storedPrices = JSON.parse(sessionStorage.getItem('original_prices') || '{}');
      const originalTotal = parseFloat(sessionStorage.getItem('original_total') || '0') / 100;

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          console.log('[QR Discount] Current cart:', cart);

          // Update item displays
          cart.items.forEach((item, index) => {
            const cartItemElement = findCartItemElement(item, index);

            if (cartItemElement) {
              // Get original price (prefer compare_at_price if available)
              const originalData = storedPrices[item.key] || {};
              const comparePrice = item.compare_at_price || originalData.compare_at_price;
              const originalPrice = comparePrice ? comparePrice / 100 :
                                   (originalData.original_price || item.original_price || item.price) / 100;
              const currentPrice = item.final_price / 100;

              // Don't update free gifts
              if (item.price === 0 || currentPrice === 0) {
                console.log('[QR Discount] Skipping free gift:', item.title);
                return;
              }

              // Update price display
              updateItemPriceDisplay(cartItemElement, originalPrice, currentPrice);
            }
          });

          // Update subtotal
          const currentTotal = cart.total_price / 100;
          const discountAmount = cart.total_discount / 100;
          const calculatedOriginal = originalTotal || (currentTotal + discountAmount);

          // updateSubtotalDisplay(calculatedOriginal, currentTotal, discountAmount);

          // Add discount summary
          // if (discountAmount > 0) {
          //   addDiscountSummary(discountCode, discountAmount);
          // }

          // Update totals and subtotals
            updateTotalAndSubtotal();

             // Remove any duplicate price containers
  removeDuplicatePriceContainers();
        });
    }

    // Find cart item element
    function findCartItemElement(item, index) {
      // Try multiple selectors
      return document.querySelector(`.cart__item[data-key="${item.key}"]`) ||
             document.querySelector(`.cart__item[data-variant-id="${item.variant_id}"]`) ||
             document.querySelector(`.cart-item[data-product-id="${item.product_id}"]`) ||
             document.querySelectorAll('.cart__item, .cart-item, [data-cart-item]')[index];
    }


    
  // Remove duplicate price containers
  function removeDuplicatePriceContainers() {
    // Get all cart items
    const cartItems = document.querySelectorAll('.cart__item, .cart-item, [data-cart-item]');

    cartItems.forEach(cartItem => {
      // Find all price-container divs within each cart item
      const priceContainers = cartItem.querySelectorAll('.price-container');

      // If more than one price-container exists, hide the duplicates
      if (priceContainers.length > 1) {
        console.log(`[QR Discount] Found ${priceContainers.length} price containers, hiding duplicates`);

        // Keep the first one, hide the rest
        for (let i = 1; i < priceContainers.length; i++) {
          priceContainers[i].style.display = 'none';
          console.log('[QR Discount] Hiding duplicate price container');
        }
      }
    });
  }


         // Update total and subtotal displays
  function updateTotalAndSubtotal() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const currentTotal = cart.total_price / 100;

        // Update each item's total price (the line total)
        cart.items.forEach((item, index) => {
          const cartItemElement = findCartItemElement(item, index);

          if (cartItemElement) {
            const totalPriceElement = cartItemElement.querySelector('.price_total .money');

            if (totalPriceElement && !totalPriceElement.dataset.totalUpdated) {
              const itemTotal = (item.final_line_price / 100).toFixed(2);
              totalPriceElement.innerHTML = `$${itemTotal}`;
              totalPriceElement.dataset.totalUpdated = 'true';
            }
          }
        });

        // Update cart subtotal (if you have a cart subtotal element)
        const cartSubtotalElement = document.querySelector('.cart-subtotal .money, .subtotal .money');
        if (cartSubtotalElement && !cartSubtotalElement.dataset.subtotalUpdated) {
          cartSubtotalElement.innerHTML = `$${currentTotal.toFixed(2)}`;
          cartSubtotalElement.dataset.subtotalUpdated = 'true';
        }
      });
  }

    // Update item price display
    function updateItemPriceDisplay(element, originalPrice, currentPrice) {
      // Skip if prices are the same (no discount) or if it's a free item
      if (originalPrice === currentPrice || currentPrice === 0) return;

      // Find price container
      const priceElements = element.querySelectorAll('.modal_price .money');

      priceElements.forEach(priceEl => {
        if (!priceEl.dataset.qrUpdated) {
          priceEl.innerHTML = `
            <div class="price-container">
              <span style="text-decoration: line-through; color: #999; margin-right: 8px;">
                $${originalPrice.toFixed(2)}
              </span>
              <span style="color: #198754; font-weight: bold;">
                $${currentPrice.toFixed(2)}
              </span>
            </div>
          `;
          priceEl.dataset.qrUpdated = 'true';
        }
      });
    }

    // Update subtotal display
    // function updateSubtotalDisplay(original, current, savings) {
    //   const subtotalElements = document.querySelectorAll('.cart__subtotal, .subtotal, .cart-subtotal, [data-cart-subtotal]');

    //   subtotalElements.forEach(element => {
    //     if (!element.dataset.qrUpdated && savings > 0) {
    //       element.innerHTML = `
    //         <div style="text-align: right;">
    //           <div style="text-decoration: line-through; color: #999; font-size: 0.9em;">
    //             $${original.toFixed(2)}
    //           </div>
    //           <div style="color: #198754; font-weight: bold; font-size: 1.2em;">
    //             $${current.toFixed(2)}
    //           </div>
    //           <div style="color: #4CAF50; font-size: 0.85em; margin-top: 4px;">
    //             You save $${savings.toFixed(2)} (${CONFIG.discountPercentage}% OFF)
    //           </div>
    //         </div>
    //       `;
    //       element.dataset.qrUpdated = 'true';
    //     }
    //   });
    // }

    // Show applying message
    function showApplyingMessage() {
      const message = document.createElement('div');
      message.id = 'qr-applying-message';
      message.style.cssText = `
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
        padding: 30px;
        border-radius: 10px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.3);
        z-index: 999999;
        text-align: center;
      `;

      message.innerHTML = `
        <div style="font-size: 40px; margin-bottom: 15px;">🎁</div>
        <h3 style="margin: 0 0 10px;">Applying Your Discount...</h3>
        <p style="margin: 0; color: #666;">Please wait a moment</p>
      `;

      document.body.appendChild(message);
    }

    // Add discount summary
    // function addDiscountSummary(discountCode, amount) {
    //   if (document.getElementById('qr-discount-summary') || amount <= 0) return;

    //   const summary = document.createElement('div');
    //   summary.id = 'qr-discount-summary';
    //   summary.style.cssText = `
    //     background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    //     color: white;
    //     padding: 15px 20px;
    //     border-radius: 8px;
    //     margin: 20px 0;
    //   `;

    //   summary.innerHTML = `
    //     <div style="display: flex; justify-content: space-between; align-items: center;">
    //       <div>
    //         <strong>QR Code Discount Applied!</strong>
    //         <div style="font-size: 14px; opacity: 0.9;">Code: ${discountCode}</div>
    //       </div>
    //       <div style="text-align: right;">
    //         <div style="font-size: 20px; font-weight: bold;">-$${amount.toFixed(2)}</div>
    //         <div style="font-size: 12px;">${CONFIG.discountPercentage}% OFF</div>
    //       </div>
    //     </div>
    //   `;

    //   const cartContainer = document.querySelector('.cart, .cart-container');
    //   if (cartContainer) {
    //     cartContainer.insertBefore(summary, cartContainer.firstChild);
    //   }
    // }

    // Show notifications
    function showDiscountSavedNotification(discountCode) {
      const notification = document.createElement('div');
      notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        padding: 20px 25px;
        border-radius: 10px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.3);
        z-index: 999999;
        animation: slideIn 0.5s ease;
        max-width: 350px;
      `;

      notification.innerHTML = `
        <div style="display: flex; align-items: center;">
          <div style="font-size: 30px; margin-right: 15px;">✨</div>
          <div>
            <strong style="font-size: 16px; display: block; margin-bottom: 5px;">
              Discount Code Saved!
            </strong>
            <span style="font-size: 14px;">
              Your 10% discount will be applied in cart.
            </span>
          </div>
        </div>
        <button onclick="this.parentElement.remove()"
                style="position: absolute; top: 10px; right: 10px; background: none;
                       border: none; color: white; font-size: 20px; cursor: pointer;">×</button>
      `;

      document.body.appendChild(notification);
      setTimeout(() => notification.remove(), 6000);
    }

    // function showPendingDiscountNotification(discountCode) {
    //   const notification = document.createElement('div');
    //   notification.style.cssText = `
    //     position: fixed;
    //     top: 20px;
    //     right: 20px;
    //     background: linear-gradient(135deg, #FFA500 0%, #FF6347 100%);
    //     color: white;
    //     padding: 20px 25px;
    //     border-radius: 10px;
    //     box-shadow: 0 10px 30px rgba(0,0,0,0.3);
    //     z-index: 999999;
    //     animation: slideIn 0.5s ease;
    //   `;

    //   notification.innerHTML = `
    //     <div>
    //       <strong>Discount Ready!</strong>
    //       <p style="margin: 5px 0;">Your 10% discount will apply in cart.</p>
    //       <button onclick="window.location.href='/cart'"
    //               style="background: white; color: #FF6347; border: none;
    //                      padding: 8px 16px; border-radius: 5px; cursor: pointer;">
    //         Go to Cart →
    //       </button>
    //     </div>
    //     <button onclick="this.parentElement.remove()"
    //             style="position: absolute; top: 10px; right: 10px; background: none;
    //                    border: none; color: white; font-size: 20px; cursor: pointer;">×</button>
    //   `;

    //   document.body.appendChild(notification);
    //   setTimeout(() => notification.remove(), 8000);
    // }

    // Show badge
    function showActiveDiscountBadge(discountCode) {
      if (document.getElementById('qr-discount-badge')) return;

      const badge = document.createElement('div');
      badge.id = 'qr-discount-badge';
      badge.style.cssText = `
        position: fixed;
        bottom: 20px;
        left: 20px;
        background: #4CAF50;
        color: white;
        padding: 12px 18px;
        border-radius: 25px;
        box-shadow: 0 4px 10px rgba(0,0,0,0.2);
        z-index: 99999;
        font-size: 14px;
        display: flex;
        align-items: center;
        cursor: pointer;
      `;

      badge.innerHTML = `
        <span style="margin-right: 8px; pointer-events: none;">✨</span>
        <span>10% OFF ${window.location.pathname === '/cart' ? 'Applied' : 'Ready'}</span>
      `;

      // if (window.location.pathname !== '/cart') {
      //   badge.onclick = () => window.location.href = '/cart';
      // }

      document.body.appendChild(badge);
    }

    // Add styles
    const style = document.createElement('style');
    style.textContent = `
      @keyframes slideIn {
        from { transform: translateX(400px); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
    `;
    document.head.appendChild(style);

    // Debug functions
    window.checkQRDiscount = function() {
      const discount = CookieManager.get(CONFIG.cookieName);
      console.log('Stored discount:', discount);
      console.log('Original prices:', sessionStorage.getItem('original_prices'));
      return discount;
    };

    window.clearQRDiscount = function() {
      CookieManager.remove(CONFIG.cookieName);
      sessionStorage.clear();
      document.getElementById('qr-discount-badge')?.remove();
      document.getElementById('qr-discount-summary')?.remove();
      console.log('QR discount cleared');
      window.location.reload();
    };

  })();